import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// ✅ Register Service Worker with automatic update handling
if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
        // Register service worker with root scope to control entire site
        navigator.serviceWorker
            .register("/service-worker.js", {
                scope: "/", // ⭐ Control entire site, not just /build/
                updateViaCache: "none", // Always check for updates
            })
            .then((reg) => {
                console.log("✅ Service Worker registered:", reg);

                // ⭐ Check for updates every hour
                setInterval(() => {
                    reg.update();
                }, 60 * 60 * 1000); // 1 hour

                // 🆕 Detect if a new service worker is found
                reg.onupdatefound = () => {
                    const installingWorker = reg.installing;

                    installingWorker.onstatechange = () => {
                        if (installingWorker.state === "installed") {
                            if (navigator.serviceWorker.controller) {
                                // New content available - old SW is controlling now
                                console.log("🔁 New version available. Reloading...");

                                // ⭐ Automatically reload after a short delay
                                setTimeout(() => {
                                    window.location.reload();
                                }, 1000);
                            } else {
                                // First time SW install
                                console.log("📦 Content is cached for offline use.");
                            }
                        }
                    };
                };

                // ⭐ Listen for messages from service worker
                navigator.serviceWorker.addEventListener('controllerchange', () => {
                    // Service worker controller changed, reload to get new version
                    console.log("🔄 Service Worker controller changed. Reloading...");
                    window.location.reload();
                });

                // ⭐ Listen for messages from service worker
                navigator.serviceWorker.addEventListener('message', (event) => {
                    if (event.data && event.data.type === 'SW_ACTIVATED') {
                        if (event.data.action === 'reload') {
                            console.log("🔄 Service Worker activated. Reloading page...");
                            window.location.reload();
                        }
                    }
                });
            })
            .catch((err) => {
                console.error("❌ Service Worker registration failed:", err);
            });
    });
}

// ✅ Handle Install Prompt (PWA)
let deferredPrompt;
window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault();
    deferredPrompt = event;

    console.log("📢 Install prompt is ready!");
});
